import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box, TableCell } from '@mui/material';
import { memo } from 'react';
import ConversionRing from '../../../components/ConversionRing';
import useMoney from '../../../hooks/useMoney';
import { SalesOpportunityConversionByCategory } from '../../sales-opportunity/salesOpportunity.types';

interface SalesOpportunityCategoryItemProps {
  salesOpportunityCategory: SalesOpportunityConversionByCategory;
}

const SalesOpportunityCategoryItem = ({
  salesOpportunityCategory,
}: SalesOpportunityCategoryItemProps) => {
  const { formatAbreviatedMoney } = useMoney();

  return (
    <>
      <TableCell sx={{ maxWidth: '134px' }}>
        <Tooltip fullWidth TooltipContent={salesOpportunityCategory.categoryName}>
          <Typography noWrap variant="body2">
            {salesOpportunityCategory.categoryName}
          </Typography>
        </Tooltip>
      </TableCell>
      <TableCell>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            minWidth: '133px',
          }}
        >
          <Typography variant="body2">
            {formatAbreviatedMoney(Number(salesOpportunityCategory?.achievedValue ?? 0))} /{' '}
            {formatAbreviatedMoney(Number(salesOpportunityCategory?.opportunityValue ?? 0))}
          </Typography>
        </Box>
      </TableCell>
      <TableCell>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            minWidth: '83px',
          }}
        >
          <ConversionRing
            horizontalSpacing={8}
            thickness={10}
            size={20}
            value={Number(salesOpportunityCategory?.conversion ?? 0)}
            showTextLeftSide
          />
        </Box>
      </TableCell>
    </>
  );
};

export default memo(SalesOpportunityCategoryItem);
